var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgShare = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/export"
  }, /*#__PURE__*/React.createElement("g", {
    id: "export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.334 9.16671L18.1673 2.33337",
    stroke: "#333335",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.834 5.66663V1.66663H14.834",
    stroke: "#333335",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.66602 1.66663H7.99935C3.83268 1.66663 2.16602 3.33329 2.16602 7.49996V12.5C2.16602 16.6666 3.83268 18.3333 7.99935 18.3333H12.9993C17.166 18.3333 18.8327 16.6666 18.8327 12.5V10.8333",
    stroke: "#333335",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share.ae5beb03.svg";
export { ForwardRef as ReactComponent };